import { DisabledPrompt, useRoute } from "@bcm-dev/bcms-vite";
import React, { useState } from "react";

import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UIPrimaryButton } from "components/ui/UIButton";
import UISearch from "components/ui/UISearch";
import UITextInput from "components/ui/UITextInput";
import { ImageAsset, SVGAsset } from "res";

import "./styles.css";

/**
 * @function RegionPage
 * @return {React.Component}
 * @exported true
 * @description The main component for RegionPage
 * @example
 * <RegionPage />
 */
export default function RegionPage(props) {
  const navigate = useRoute();
  
  const [ state, setState ] = useState("");
  const onChange = value => setState(value);

  return(
    <MainContentContainer header={<MainContentHeader text="Region" />} className="region-page">
      <FormContainer>
        <FormRow>
          <DisabledPrompt>
            <UISearch placeholder="Search Country, State, City, Zip" />
          </DisabledPrompt>
        </FormRow>
        <FormRow>
          <ImageAsset id="MapLocationImage" className="map" />
        </FormRow>
        <FormRow>
          <div className="flex-container align-center-container">
            <SVGAsset id="InformationIcon" className="set-width left-inline-icon" />
            <p className="sub-text">Approximate visible/outlined area is set as your region</p>
          </div>
        </FormRow>
        <FormRow>
          <UITextInput placeholder="Region Name" value={ state } onChange={ onChange } />
        </FormRow>
        <FormButtonContainer>
          <DisabledPrompt>
            <UIPrimaryButton text="Save" />
          </DisabledPrompt>
        </FormButtonContainer>
      </FormContainer>
    </MainContentContainer>
  );
}